export const getFullName = (user: {
  firstName: string;
  lastName: string;
  middleName?: string;
  short?: boolean;
}): string => {
  const { firstName, lastName, middleName, short } = user;

  const shortedMiddleName = middleName ? `${middleName[0]}.` : "";

  return middleName
    ? `${firstName} ${short ? shortedMiddleName : middleName} ${lastName}`
    : `${firstName} ${lastName}`;
};
